import { Component} from '@angular/core';

@Component({
  selector: 'lib-pdf-svg',
  templateUrl: './pdf.component.svg',
})
export class PdfSvgComponent {
  fillColor = 'rgb(166, 46, 46)';
}

